import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

export type PulseResponse = {
  committerDataPath: string
  diffstatSummaryPath: string
  overviewDataPath: string
}

export function buildPulseRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pulseRoute', {
    path: '/:owner/:repo/pulse',
    queries: [mainQuery<PulseResponse>()],
  })
}
